module.exports = __webpack_public_path__ + "static/img/menu1.25b3642d.png";